<template>
  <div :key="'options' + key">
    <div v-if="filtre.champ === 'input'" class="filtre">
      <input :disabled="disabled" :type="filtre.type" v-model="filtreLocal.selection" :placeholder="filtre.label" :class="filtre.class || ''" :style="'width:' + (filtre.width || '250px')" @input="appliquerFiltre(filtre)" @blur="appliquerFiltre(filtre)" @focus="$event.target.select()">
    </div>
    <div v-if="filtre.champ === 'select'" class="filtre">
      <MultiSelect v-if="filtre.type === 'multi'" :disabled="disabled" :value="filtre.selection" :items="options" itemText="texte" itemValue="valeur" itemClass="class" itemStyle="style" itemIcone="icone" :placeholder="filtre.label" emptyText="Toutes les valeurs disponibles ont été ajoutées" :style="'min-width:' + (filtre.width || '300px')" @input="appliquerFiltre(filtre, $event)" />
      <v-select v-else :disabled="disabled" v-model="filtreLocal.selection" :options="options" label="texte" value="valeur" :clearable="false" :placeholder="filtre.label" :style="'min-width:' + (filtre.width || '300px')" @input="appliquerFiltre(filtre)">
        <template v-slot:selected-option="option">
          <span :class="option.class" :style="option.style"><span></span><i v-if="option.icone" :class="option.icone"></i>{{ option.texte }}<span></span></span>
        </template>
        <template v-slot:option="option">
          <span :class="option.class" :style="option.style"><span></span><i v-if="option.icone" :class="option.icone"></i>{{ option.texte }}<span></span></span>
        </template>
      </v-select>
    </div>
    <div v-if="filtre.champ === 'datepicker'" class="filtre">
      <v-date-picker v-if="filtre.type === 'multi'" class="date-picker" :disabled="disabled" :disabled-dates="filtre.disabledDates" :available-dates="filtre.availableDates" is-range :columns="2" :step="1" v-model="filtreLocal.selection" :popover="{ visibility: 'click' }" @input="appliquerFiltre(filtre)">
        <template v-slot="{ inputValue, inputEvents }">
          <input :value="filtre.customText ? filtre.customText(filtre) : inputValue.start || inputValue.end ? inputValue.start + ' au ' + inputValue.end : filtre.label" v-on="inputEvents.start" :style="'width:' + (filtre.width || '195px')" />
        </template>
      </v-date-picker>
      <v-date-picker v-else class="date-picker" :disabled="disabled" :disabled-dates="filtre.disabledDates" :available-dates="filtre.availableDates" :columns="1" :step="1" v-model="filtreLocal.selection" :popover="{ visibility: 'click' }" @input="appliquerFiltre(filtre)">
        <template v-slot="{ inputValue, inputEvents }">
          <input :value="filtre.customTextSemaine ? customTextSemaine(filtre.selection) : inputValue ? inputValue : filtre.label" v-on="inputEvents" :style="'width:' + (filtre.width || '100px')" />
        </template>
      </v-date-picker>
    </div>
    <div v-if="filtre.champ === 'checkbox'" class="filtre">
      <label class="label-checkbox mb-2">
        <input type="checkbox" v-model="filtreLocal.selection" @change="appliquerFiltre(filtre)">
        <span class="ml-2">{{ filtre.label }}</span>
      </label>
    </div>
    <div v-if="filtre.champ === 'btn'" class="filtre">
      <b-button class="btn" :class="filtre.class ? filtre.class : 'btn-primary'" :hidden="filtre.hidden" :disabled="disabled || filtre.disabled" @click="executerAction(filtre)"><i v-if="filtre.picto" :class="filtre.picto"></i>{{ filtre.label }}</b-button>
    </div>
  </div>
</template>

<script>
import MultiSelect from "@/components/Inputs/MultiSelect"
import { getLundiDeLaSemaine, getDimancheDeLaSemaine } from '@/mixins/index'

export default {
  name: "OptionsBarreFiltres",
  props: [ "filtre", "disabled" ],
  mixins: [ getLundiDeLaSemaine, getDimancheDeLaSemaine ],
  components: { MultiSelect },
  data() {
    return {
      key: 1
    }
  }, 
  mounted() {
  },
  computed: {
    options() {
      return this.filtre.options || []
    },
    filtreLocal: {
      get: function() {
        return this.filtre
      },
      set: function() {
        this.$emit("appliquer-filtre", this.filtre.filtrer)
      }
    }
  },
  watch: {
    options() {
      this.key++
    }
  },
  methods: {
    customTextSemaine(dateSelectionnee) {
      let date = dateSelectionnee || new Date()
      
      let lundi = this.getLundiDeLaSemaine(date)
      let dimanche = this.getDimancheDeLaSemaine(date)

      return lundi.toLocaleDateString('fr-FR') + ' au ' + dimanche.toLocaleDateString('fr-FR')
    },
    executerAction(filtre) {
      this.$emit("executer-action", filtre.filtrer)
    },
    appliquerFiltre(filtre, valeur) {
      if (filtre && valeur) {
        filtre.selection = valeur
      }
      this.$emit("appliquer-filtre", filtre.filtrer)
    },
  }
}
</script>
